'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    const isStaleBundle =
      error?.message?.includes("Cannot read properties of undefined (reading 'call')") ||
      error?.message?.includes('ChunkLoadError') ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Failed to fetch dynamically imported module');

    if (isStaleBundle) {
      window.location.reload();
    }
  }, [error]);

  return (
    <div
      style={{
        margin: 0,
        minHeight: '100vh',
        background: '#0A0A12',
        color: '#F0F0F5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.5rem' }}>
          Something went wrong
        </h2>
        <p style={{ color: '#9CA3AF', marginBottom: '1.5rem', fontSize: '0.875rem' }}>
          A page update is available. Refreshing to load the latest version…
        </p>
        <button
          onClick={() => reset()}
          style={{
            padding: '0.625rem 1.5rem',
            borderRadius: '0.75rem',
            background: '#FFD700',
            color: '#000',
            fontWeight: 700,
            fontSize: '0.875rem',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
